import React from 'react';
import {connect} from 'react-redux';

// Components
import Anchor from 'Components/common/Anchor';

// Actions
import {getOrderDetailMessageList} from 'Actions/host';
import {addMessage} from 'Actions/taskManagement';
import {T} from 'Actions/translate';

// Icons
import {ArrowBackIos} from '@material-ui/icons';
import {Grid} from '@material-ui/core';
import BasicButton from 'Components/common/BasicButton';
import {openNotification} from 'Actions/notification';
import BasicTextArea from 'Components/common/BasicTextArea';

class MessageList extends React.Component {
    state = {
        messageList: [],
        hostComments: '',
    };

    componentWillMount() {
        this.getInitData();
    }

    getInitData = () => {
        let search = this.props.location.search.substring(1);
        let arr = search.split('&');
        this.params = {};

        arr.forEach((item) => {
            let temp = item.split('=');

            this.params[temp[0]] = temp[1];
        });

        if (this.params.eoneNumber) {
            this.props
                .getOrderDetailMessageList({
                    messageKey: this.params.eoneNumber,
                    messageMode:
                        this.params.hasOwnProperty('messageType') &&
                        this.params.messageType === 'TASK'
                            ? 'TASK'
                            : 'ORDER',
                })
                .then((res) => {
                    if (
                        res &&
                        res.status === 'success' &&
                        res.data.length > 0
                    ) {
                        let currentMessageList = res.data;
                        this.setState({
                            messageList: currentMessageList,
                        });
                    }
                });
        }
    };

    goBack = () => {
        this.props.history.goBack();
    };

    handleTextArea = (name, value) => {
        if (value && value.length > 0) {
            this.setState({
                hostComments: value,
            });
        }
    };

    clearInput = () => {
        this.setState({
            hostComments: '',
        });
    };
    getRouteParams = () => {
        let search = this.props.location.search.substring(1);
        let arr = search.split('&');
        this.params = {};

        arr.forEach((item) => {
            let temp = item.split('=');

            this.params[temp[0]] = temp[1];
        });
        return this.params;
    };

    saveMessage = () => {
        const {hostComments, messageList} = this.state;
        console.log('saveTask hostComments', hostComments);
        if (!hostComments || (hostComments && !hostComments.trim())) {
            this.props.openNotification(
                T('task_progress_task_comments_not_null'),
            );
            return false;
        }

        let params = {
            messageKey: this.getRouteParams().eoneNumber,
            content: hostComments ? hostComments.trim() : '',
            messageMode: 'TASK',
            toUserId: messageList.length > 0 && messageList[0].fromUserId,
            messageId: this.getRouteParams().messageId,
            remark:
                this.getRouteParams().remark && this.getRouteParams().remark,
        };

        this.props.addMessage(params).then((res) => {
            // console.log('saveTask', res);
            if (res && res.status === 'success') {
                this.props.openNotification(
                    T('task_details_messge_send_success'),
                    'success',
                );

                this.getInitData();
                this.setState({
                    hostComments: '',
                });
            }
        });
    };

    render() {
        const {messageList, hostComments} = this.state;

        return (
            <div className="message-list-container">
                <div className="header-wrap">
                    <div className="message-list-header container-max-width is-fixed">
                        <Anchor
                            className="go-back"
                            onClickOfSingleTap={this.goBack}>
                            <ArrowBackIos />
                        </Anchor>
                        {T('host_message_list')}
                    </div>
                </div>
                {messageList.length > 0 ? (
                    <ul className="message-list">
                        {messageList.map((item, index) => (
                            <li className="message-item" key={index}>
                                <div className="message-content">
                                    <div className="first-row">
                                        <div className="eone-number">
                                            {item.messageMode === 'TASK'
                                                ? item.messageId
                                                : item.messageKey}
                                        </div>
                                        <div className="create-time">
                                            {item.createTime}
                                        </div>
                                    </div>
                                    <div className={'admin-container'}>
                                        <div className="first-column">
                                            {item.fromUserName !==
                                            '系统提示' ? (
                                                <div>
                                                    {T(
                                                        item.messageMode ===
                                                            'TASK'
                                                            ? 'host_message_list_from_user_name'
                                                            : 'host_message_list_admin',
                                                    )}
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                            <div
                                                className={
                                                    item.fromUserName ===
                                                    '系统提示'
                                                        ? ''
                                                        : 'admin-value'
                                                }>
                                                {item.fromUserName}
                                            </div>
                                        </div>
                                        <div className="sencond-column">
                                            <div>
                                                {T(
                                                    'host_message_list_to_user_name',
                                                )}
                                            </div>
                                            <div className="admin-value">
                                                {item.toUserNameList &&
                                                item.toUserNameList.length > 0
                                                    ? item.toUserNameList.join(
                                                          '，',
                                                      )
                                                    : ''}
                                            </div>
                                        </div>
                                    </div>
                                    {item.messageMode === 'TASK' &&
                                    item.category &&
                                    item.subcategories &&
                                    item.subcategories.length > 0 ? (
                                        <div className={'admin-container'}>
                                            <div className="first-column">
                                                {T(
                                                    'host_message_list_task_category',
                                                )}
                                                {item.category}
                                            </div>
                                            <div className="sencond-column">
                                                {T(
                                                    'host_message_list_task_subcategory',
                                                )}
                                                {item.subcategories.join(',')}
                                            </div>
                                        </div>
                                    ) : null}

                                    {/* {item.messageMode === 'TASK' &&
                                    item.content ? (
                                        <p className="admin-container">
                                            {T('host_message_list_task_comments')}
                                            <div className='task-comments-container'>{item.content}</div>
                                        </p>
                                    ) : null} */}

                                    <div className="item-content">
                                        {item.content}
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                ) : null}

                {this.params.hasOwnProperty('messageType') &&
                    this.params.messageType === 'TASK' && (
                        <div className="content-box">
                            <Grid item xs={12} className="host-reply-message">
                                <div>{T('task_details_message_desc')}：</div>
                                <BasicTextArea
                                    type="text"
                                    inputValid={this.handleTextArea}
                                    clearInput={this.clearInput}
                                    defalutValue=""
                                    value={hostComments}
                                />
                            </Grid>
                        </div>
                    )}

                {this.params.hasOwnProperty('messageType') &&
                    this.params.messageType === 'TASK' && (
                        <div className="assignment-customer-btn-wrapper">
                            <BasicButton
                                type="primary"
                                className="basic-style add-message-btn"
                                onClickOfSingleTap={() => {
                                    this.saveMessage();
                                }}
                                isStopPropagation={true}>
                                {T('task_details_submit')}
                            </BasicButton>
                        </div>
                    )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {localData} = state;
    return {
        localData,
    };
};

const mapDispatchToProps = {
    getOrderDetailMessageList,
    openNotification,
    addMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageList);
